import React, { useMemo, forwardRef, useImperativeHandle, useRef } from 'react';
import LifeCycleModule from '@modules/projects/projectDetail/lifeCycle/lifeCycle.module';
import { processRawLifecycleData } from '@service/apis';
import './styles.scss';

function LifecycleTemplate(
  { data, instanceId, instanceName, refreshScrollDetection, formChange },
  ref,
) {
  const dataForEdit = useMemo(
    () => (data ? processRawLifecycleData(data) : null),
    [data],
  );
  const moduleRef = useRef();

  useImperativeHandle(
    ref,
    () => ({
      validateFields() {
        return moduleRef.current?.validate();
      },
      updateTitle(title) {
        // eslint-disable-next-line no-unused-expressions
        moduleRef.current?.updateTitle(title);
      },
    }),
    [],
  );

  return (
    <div className="lifecycle-template">
      {dataForEdit ? (
        <LifeCycleModule
          titleName={data?.lifecycleSectionInfo?.sectionTitle}
          data={dataForEdit}
          projectId={null}
          instanceId={instanceId}
          type={instanceName === 'Sell-Side' ? 'Divestiture' : 'Integration'}
          // identifier="lifecycleIntegration"
          projectStatusRefresher={() => {}}
          isTemplate={true}
          ref={moduleRef}
          key={instanceId}
          refreshScrollDetection={refreshScrollDetection}
          formChange={formChange}
        />
      ) : null}
    </div>
  );
}

export default forwardRef(LifecycleTemplate);
